import { useInView } from "@/hooks/useInView";

const partners = [
  "Fortis MMA",
  "Labori Boxing",
  "The Museum School of East Dallas",
  "After8toEducate",
  "Dallas Children's Advocacy Center",
  "The Net",
  "One Safe Place",
  "Gray Reed",
];

export default function CommunitySection() {
  const [ref, inView] = useInView();

  return (
    <section id="community" data-testid="community-section" className="bg-[#050505] py-16 sm:py-24" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4 reveal ${inView ? "visible" : ""}`}>
          Community Impact
        </p>
        <h2 className={`font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-6 reveal ${inView ? "visible" : ""} stagger-1`}>
          Serving Communities Across DFW.
        </h2>
        <p className={`text-[#8C8C8C] font-body leading-relaxed max-w-3xl mb-12 reveal ${inView ? "visible" : ""} stagger-2`}>
          3SM methods and programming are currently being delivered across gyms, schools, nonprofit organizations, professional environments, and community programs throughout DFW.
        </p>

        <div className={`grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-4 border-y border-white/10 py-10 mb-12 reveal ${inView ? "visible" : ""} stagger-3`}>
          {partners.map((p) => (
            <div
              key={p}
              data-testid={`partner-${p.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="text-[#F2EFE9] font-heading font-semibold text-sm sm:text-base tracking-tight"
            >
              {p}
            </div>
          ))}
        </div>

        <blockquote className={`text-[#D5CFC8] font-body italic text-base sm:text-lg leading-relaxed max-w-3xl reveal ${inView ? "visible" : ""} stagger-4`}>
          &ldquo;From private sessions to workshops of 40 or more participants, 3SM adapts its methods to the people and environment being served.&rdquo;
        </blockquote>
      </div>
    </section>
  );
}
